import React from 'react';
import { SvgIcon } from 'shared/components/SvgIcon';

interface Props {
	className?: string;
	active?: boolean;
	id: string | number;
}

export const GetSportIcon: React.FC<Props> = (props) => (
	<SvgIcon type="sport" iconId={props.id} id={`sport-icon-${props.id}`} className={props.className} />
);
